const C = {
  name: "AppsFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 4C13 2.34772 14.3477 1 16 1H20C21.6523 1 23 2.34772 23 4V8C23 9.65228 21.6523 11 20 11H16C14.3477 11 13 9.65228 13 8V4ZM16 3C15.4523 3 15 3.45228 15 4V8C15 8.54772 15.4523 9 16 9H20C20.5477 9 21 8.54772 21 8V4C21 3.45228 20.5477 3 20 3H16Z" fill="currentColor"/>
<path d="M4 13C2.34772 13 1 14.3477 1 16V20C1 21.6523 2.34772 23 4 23H8C9.65228 23 11 21.6523 11 20V16C11 14.3477 9.65228 13 8 13H4Z" fill="currentColor"/>
<path d="M4 1C2.34772 1 1 2.34772 1 4V8C1 9.65228 2.34772 11 4 11H8C9.65228 11 11 9.65228 11 8V4C11 2.34772 9.65228 1 8 1H4Z" fill="currentColor"/>
<path d="M16 13C14.3477 13 13 14.3477 13 16V20C13 21.6523 14.3477 23 16 23H20C21.6523 23 23 21.6523 23 20V16C23 14.3477 21.6523 13 20 13H16Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as AppsFilled
};
